export default __webpack_public_path__ + "static/greycliff-cf-heavy-8c422cad0d14c9ff73259b9878e98215.woff2";